import React, { useState } from 'react';
import { Container, Paper, TextField, Button, Typography, Box } from '@mui/material';
import useStore from '../store/useStore';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const login = useStore((state) => state.login);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(form);
      navigate('/'); // Volver al catálogo
    } catch (error) {
      alert("Credenciales incorrectas");
    }
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 10 }}>
      <Paper sx={{ p: 4, borderRadius: 3, textAlign: 'center' }}>
        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 3 }}>
          Iniciar Sesión
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth label="Usuario"
            margin="normal"
            onChange={(e) => setForm({ ...form, username: e.target.value })}
          />
          <TextField
            fullWidth label="Contraseña"
            type="password"
            margin="normal"
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
          <Button 
            fullWidth variant="contained" 
            type="submit"
            sx={{ mt: 3, bgcolor: '#0f172a', py: 1.5 }}
          >
            Entrar
          </Button>
          <Button
            onClick={()=>{
                navigate('/registrarse');
            }}>
            Registrarse
          </Button>
        </form>
      </Paper>
    </Container>
  );
}